export enum EnterpriseSubscriptionType {
    basic = 'Basic',
    premium = 'Premium'
}
